import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { ErrorAlert } from '../../components/ErrorAlert';
import type { ReactNode } from 'react';

export type ConfirmDialogProps = {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Two-button modal — kept minimal until the real workflow dialog lands.
 * Used for destructive actions (deactivate user, delete role, etc).
 */
export function ConfirmDialog(props: ConfirmDialogProps) {
  const {
    open, title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel',
    destructive = false, busy = false, error, onConfirm, onCancel,
  } = props;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{message}</DialogContentText>
        {error && <ErrorAlert sx={{ mt: 2 }}>{error}</ErrorAlert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={busy}>{cancelLabel}</Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          disabled={busy}
        >
          {busy ? 'Working…' : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
